'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _xmpp = require('@xmpp/client/dist/xmpp');
var _plugin = require('../../plugin');
var _plugin2 = _interopRequireDefault(_plugin);
var _hook = require('../infra/hook');
var _hook2 = _interopRequireDefault(_hook);
var _safeSender = require('../infra/safeSender');
var _safeSender2 = _interopRequireDefault(_safeSender);
var _timeDeltaHelper = require('../../helpers/timeDeltaHelper');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function isPresenceWithTimestamp(stanza) {
  return stanza && stanza.is('presence') && stanza.getChild('status');
}
var UserPresence = function (_Plugin) {
  _inherits(UserPresence, _Plugin);
  function UserPresence(entity) {
    _classCallCheck(this, UserPresence);
    var _this = _possibleConstructorReturn(this, (UserPresence.__proto__ || Object.getPrototypeOf(UserPresence)).call(this, entity));
    _this.handler = function () {
      return _this.safeSender.send((0, _xmpp.xml)('presence')).then(function (responseStanza) {
        if (isPresenceWithTimestamp(responseStanza)) {
          _this.entity.timestampDelta = (0, _timeDeltaHelper.calcTimestampDelta)(responseStanza.getChildText('status'));
        }
        return responseStanza;
      }).catch(function (ex) {
        _this.entity.disconnectAndConnect();
        throw ex;
      });
    };
    _this.hook.add('online', _this.handler, 0);
    return _this;
  }
  return UserPresence;
}(_plugin2.default);
UserPresence.pluginName = 'userPresence';
UserPresence.deps = [_hook2.default, _safeSender2.default];
exports.default = UserPresence;